import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row, Input} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {downloadFile, getDatePickerProps, momentToISOFormat, selectStyles} from '../helpers/Utils';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import {NotificationManager} from '../components/common/react-notifications';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import Api from '../services/Api';
import {store} from '../AppRenderer';
import i18n from '../services/i18n';
import Select from 'react-select';
import moment from 'moment';
import fa_IR from "../constants/locales";

class TradesOutputForm extends React.Component {
  constructor(props) {
    super(props);
    this.pairOptions = [
      {label: props.t('All'), value: ''},
      ...store.getState().general.pairs.map(pair => ({
        label: props.t(pair.name), value: pair.name,
      }))
    ];
  }

  downloadOutput = async values => {
    const {pair, from, to} = values;
    const {t, financialGroupId} = this.props;
    if (Number(to.diff(from, 'days')) > 7) {
      NotificationManager.error(t('It is not possible to get output for more than 7 days.'), t('Error'));
    } else {
      try {
        const {data} = await Api.invoke(
          'GET',
          '/admin-ui/trades-download',
          null,
          {
            cancelToken: null,
            params: {
              ...(financialGroupId ? {financialGroupId} : null),
              ...(pair.value ? {pair: pair.value} : null),
              ...(from ? {from: momentToISOFormat(from)} : null),
              ...(to ? {to: momentToISOFormat(to)} : null),
            },
          },
        );
        downloadFile(data.url);
      } catch (e) {
        console.log('error: ', e);
      }
    }
  };

  render() {
    const {t} = this.props;
    return(
      <ThemeProvider
        theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          }
        })}
      >
        <FinalForm
          onSubmit={this.downloadOutput}
          initialValues={{
            pair: this.pairOptions[0],
            from: moment().subtract(7, 'days'),
            to: moment(),
          }}
          render={({handleSubmit, submitting}) => {
            return (
              <Form>
                <Row className="mb-2">
                  <Col>
                    <span className="mb-1">{t('Selected Pair')}</span>
                    <Field name="pair">
                      {({input}) => (
                        <Select
                          {...input}
                          className="w-100"
                          styles={selectStyles}
                          options={this.pairOptions}
                          onChange={pair => {input.onChange(pair);}}
                          placeholder={t('Select')}
                        />
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <span className="mb-1">{t('Start Date')}</span>
                    <Field name="from">
                      {({input}) => (
                        <MuiPickersUtilsProvider
                          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                          locale={i18n.language}
                        >
                          <DateTimePicker
                            {...getDatePickerProps()}
                            value={input.value ? input.value : null}
                            onChange={date => {input.onChange(date);}}
                            TextFieldComponent={props =>
                              <Input
                                style={{width: '100%'}}
                                placeholder={t('Select Date')}
                                {...props}
                              />
                            }
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <span className="mb-1">{t('End Date')}</span>
                    <Field name="to">
                      {({input}) => (
                        <MuiPickersUtilsProvider
                          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                          locale={i18n.language}
                        >
                          <DateTimePicker
                            {...getDatePickerProps()}
                            value={input.value ? input.value : null}
                            onChange={date => {input.onChange(date);}}
                            TextFieldComponent={props =>
                              <Input
                                style={{width: '100%'}}
                                placeholder={t('Select Date')}
                                {...props}
                              />
                            }
                          />
                        </MuiPickersUtilsProvider>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <LoaderButton
                      color="success"
                      onClick={handleSubmit}
                      loading={submitting}
                      className="text-center">
                      {t('Download Output File')}
                    </LoaderButton>
                    <Button
                      color="grey"
                      onClick={() =>{
                        ModalManager.close({
                          isOpen: false
                        });
                      }}
                      className="text-center mx-2"
                      style={{minWidth: 100}}>
                      {t('Close')}
                    </Button>
                  </Col>
                </Row>
              </Form>
            );
          }}
        />
      </ThemeProvider>
    );
  }
}

export default withTranslation()(TradesOutputForm);
